module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/196-tajikistan-9e7b03cd3d4c6edff756124a9832f75b.svg";